module.exports = [
  { code: 'Aberdeenshire', name: 'Aberdeenshire' },
  { code: 'Anglesey', name: 'Anglesey' },
  { code: 'Angus', name: 'Angus' },
  { code: 'Antrim', name: 'Antrim' },
  { code: 'Argyll & Bute', name: 'Argyll & Bute' },
  { code: 'Armagh', name: 'Armagh' },
  { code: 'Avon', name: 'Avon' },
  { code: 'Bedfordshire', name: 'Bedfordshire' },
  { code: 'Berkshire', name: 'Berkshire' },
  { code: 'Blaenau Gwent', name: 'Blaenau Gwent' },
  { code: 'Bridgend', name: 'Bridgend' },
  { code: 'Buckinghamshire', name: 'Buckinghamshire' },
  { code: 'Caerphilly', name: 'Caerphilly' },
  { code: 'Cambridgeshire', name: 'Cambridgeshire' },
  { code: 'Cardiff', name: 'Cardiff' },
  { code: 'Cardiganshire', name: 'Cardiganshire' },
  { code: 'Carmarthenshire', name: 'Carmarthenshire' },
  { code: 'Cheshire', name: 'Cheshire' },
  { code: 'Clackmannanshire', name: 'Clackmannanshire' },
  { code: 'Cleveland', name: 'Cleveland' },
  { code: 'Conwy', name: 'Conwy' },
  { code: 'Cornwall', name: 'Cornwall' },
  { code: 'Down', name: 'Down' },
  { code: 'Cumbria', name: 'Cumbria' },
  { code: 'Denbighshire', name: 'Denbighshire' },
  { code: 'Derbyshire', name: 'Derbyshire' },
  { code: 'Derry', name: 'Derry' },
  { code: 'Devon', name: 'Devon' },
  { code: 'Dorset', name: 'Dorset' },
  { code: 'Dumfries & Galloway', name: 'Dumfries & Galloway' },
  { code: 'Durham', name: 'Durham' },
  { code: 'East Ayrshire', name: 'East Ayrshire' },
  { code: 'East Dunbartonshire', name: 'East Dunbartonshire' },
  { code: 'East Lothian', name: 'East Lothian' },
  { code: 'East Renfrewshire', name: 'East Renfrewshire' },
  { code: 'East Yorkshire', name: 'East Yorkshire' },
  { code: 'Essex', name: 'Essex' },
  { code: 'Fermanagh', name: 'Fermanagh' },
  { code: 'Fife', name: 'Fife' },
  { code: 'Flintshire', name: 'Flintshire' },
  { code: 'Gloucestershire', name: 'Gloucestershire' },
  { code: 'Guernsey', name: 'Guernsey' },
  { code: 'Gwent', name: 'Gwent' },
  { code: 'Gwynedd', name: 'Gwynedd' },
  { code: 'Hampshire', name: 'Hampshire' },
  { code: 'Herefordshire', name: 'Herefordshire' },
  { code: 'Hertfordshire', name: 'Hertfordshire' },
  { code: 'Highland', name: 'Highland' },
  { code: 'Inverclyde', name: 'Inverclyde' },
  { code: 'Isle of Man', name: 'Isle of Man' },
  { code: 'Isle of Wight', name: 'Isle of Wight' },
  { code: 'Jersey', name: 'Jersey' },
  { code: 'Kent', name: 'Kent' },
  { code: 'Lancashire', name: 'Lancashire' },
  { code: 'Leicestershire', name: 'Leicestershire' },
  { code: 'Lincolnshire', name: 'Lincolnshire' },
  { code: 'London - East', name: 'London - East' },
  { code: 'London - East Central', name: 'London - East Central' },
  { code: 'London - North', name: 'London - North' },
  { code: 'London - North West', name: 'London - North West' },
  { code: 'London - South East', name: 'London - South East' },
  { code: 'London - South West', name: 'London - South West' },
  { code: 'London - West', name: 'London - West' },
  { code: 'London - West Central', name: 'London - West Central' },
  { code: 'Manchester, Greater', name: 'Manchester, Greater' },
  { code: 'Merseyside', name: 'Merseyside' },
  { code: 'Merthyr', name: 'Merthyr' },
  { code: 'Middlesex', name: 'Middlesex' },
  { code: 'Midlothian', name: 'Midlothian' },
  { code: 'Monmouthshire', name: 'Monmouthshire' },
  { code: 'Moray', name: 'Moray' },
  { code: 'Neath & Port Talbot', name: 'Neath & Port Talbot' },
  { code: 'Newport', name: 'Newport' },
  { code: 'Norfolk', name: 'Norfolk' },
  { code: 'North Ayrshire', name: 'North Ayrshire' },
  { code: 'North Lanarkshire', name: 'North Lanarkshire' },
  { code: 'North Lincolnshire', name: 'North Lincolnshire' },
  { code: 'North Yorkshire', name: 'North Yorkshire' },
  { code: 'Northamptonshire', name: 'Northamptonshire' },
  { code: 'Northumberland', name: 'Northumberland' },
  { code: 'Nottinghamshire', name: 'Nottinghamshire' },
  { code: 'Orkney', name: 'Orkney' },
  { code: 'Oxfordshire', name: 'Oxfordshire' },
  { code: 'Pembrokeshire', name: 'Pembrokeshire' },
  { code: 'Perth & Kinross', name: 'Perth & Kinross' },
  { code: 'Powys', name: 'Powys' },
  { code: 'Renfrewshire', name: 'Renfrewshire' },
  { code: 'Rhondda Cynon Taff', name: 'Rhondda Cynon Taff' },
  { code: 'Scottish Borders', name: 'Scottish Borders' },
  { code: 'Shetland Islands', name: 'Shetland Islands' },
  { code: 'Shropshire', name: 'Shropshire' },
  { code: 'Somerset', name: 'Somerset' },
  { code: 'South Ayrshire', name: 'South Ayrshire' },
  { code: 'South Lanarkshire', name: 'South Lanarkshire' },
  { code: 'South Yorkshire', name: 'South Yorkshire' },
  { code: 'Staffordshire', name: 'Staffordshire' },
  { code: 'Stirlingshire', name: 'Stirlingshire' },
  { code: 'Strathclyde', name: 'Strathclyde' },
  { code: 'Suffolk', name: 'Suffolk' },
  { code: 'Surrey', name: 'Surrey' },
  { code: 'Sussex', name: 'Sussex' },
  { code: 'Swansea', name: 'Swansea' },
  { code: 'Tayside', name: 'Tayside' },
  { code: 'Torfaen', name: 'Torfaen' },
  { code: 'Tyne & Wear', name: 'Tyne & Wear' },
  { code: 'Tyrone', name: 'Tyrone' },
  { code: 'Vale of Glamorgan', name: 'Vale of Glamorgan' },
  { code: 'Warwickshire', name: 'Warwickshire' },
  { code: 'West Dunbartonshire', name: 'West Dunbartonshire' },
  { code: 'West Lothian', name: 'West Lothian' },
  { code: 'West Midlands', name: 'West Midlands' },
  { code: 'West Yorkshire', name: 'West Yorkshire' },
  { code: 'Wiltshire', name: 'Wiltshire' },
  { code: 'Wirral', name: 'Wirral' },
  { code: 'Worcestershire', name: 'Worcestershire' },
  { code: 'Wrexham', name: 'Wrexham' },
];
